<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            Scan QR Code
          </span>
        </h2>
      </v-col>
    </v-row>
    <p>{{ settingQr.error }}</p>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div v-if="!$store.state.qrmode" class="__camera-scan">
          <qrcode-stream v-if="!paused" :camera="settingQr.camera" :paused="paused" @decode="onDecode" @init="onInit" />
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!$store.state.disable_table">
      <div class="__menu-bottom menu-full menu-camera">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div class="d-flex align-center">
            <div class="font-weight-bold subtitle-2">
              {{ $t('want_to_select_table_manually') }}
            </div>
            <v-spacer />
            <v-btn type="submit" color="primary" rounded class="text-none" @click="selectManualTable">
              {{ $t('click_here') }}
            </v-btn>
          </div>
        </v-col>
      </div>
    </v-row>
    <v-dialog v-model="dialogUniqueCode" persistent max-width="280">
      <v-card>
        <div class="card-unique-code">
          <v-btn icon class="btn-close-card-unique" @click="dialogUniqueCode = false">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
          <div class="card-unique-code-title">
            {{ $t('enter_the_code') }}
          </div>
          <div class="card-unique-code-subtitle">
            {{ $t('get_the_code_at_the_cashier') }}
          </div>
          <div class="my-6">
            <div class="">
              <InputCode v-model="form.code" :error-message="error_unique_code" />
            </div>
          </div>
          <v-btn v-if="!loadingCode" type="submit" large color="primary" block class="text-none" @click="validateCode()">
            {{ $t('next') }}
          </v-btn>
          <div v-else class="d-flex align-center justify-center">
            <v-progress-circular indeterminate color="primary" />
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  dineinchecking as dineinCheck
} from '@/api/setting'
import InputCode from '@/components/modules/InputCode'
export default {
  components: {
    InputCode
  },
  data() {
    return {
      error_unique_code: '',
      loadingCode: false,
      dialogUniqueCode: false,
      form: {
        code: ''
      },
      geoLocation: {
        location_lat: 0,
        location_lon: 0
      },
      settingQr: {
        manualtable: false,
        qrDisable: '',
        camera: 'auto',
        disableInput: true,
        error: ''
      },
      paused: false,
      origins: [],
      destinations: []
    }
  },
  created() {
    this.checkStore()
  },
  beforeDestroy() {
    this.$store.state.qrmode = false
  },
  methods: {
    selectManualTable() {
      this.$router.push({ name: 'listoutlets' }).catch(() => {})
    },
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    onDecode(url) {
      this.paused = true
      window.location.href = url
    },
    async onInit(promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.$store.state.block_camera = true
        } else if (error.name === 'NotFoundError') {
          this.settingQr.error = 'ERROR: no camera on this device'
        } else if (error.name === 'NotSupportedError') {
          this.settingQr.error = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          this.settingQr.error = 'ERROR: is the camera already in use?'
        } else if (error.name === 'OverconstrainedError') {
          this.settingQr.error = 'ERROR: installed cameras are not suitable'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.settingQr.error = 'ERROR: Stream API is not supported in this browser'
        }
      }
    },
    async checkStore() {
      var selected_store = null
      selected_store = await this.$store.state.selected_outlet
      if (selected_store) {
        this.paused = true
        if (selected_store.store_is_open === 0) {
          this.$router.push({ name: 'store_is_close' }).catch(() => {})
        } else {
          if (selected_store.setting.use_dinein === 1) {
            if (selected_store.setting.use_unique_code_checking_dinein === 0) {
              // request pak ali remove gps tanggal 24 oktober 2022
              this.$router.push({ name: 'total_guest_dinein' }).catch(() => {})

              // this.origins.push({
              //   lat: Number(selected_store.location_lat),
              //   lng: Number(selected_store.location_lon)
              // })
              // if (navigator.geolocation) {
              //   navigator.geolocation.getCurrentPosition(this.successPosition, this.failurePosition, {
              //     enableHighAccuracy: true,
              //     timeout: 5000
              //   })
              // } else {
              //   alert(`Browser doesn't support Geolocation`)
              // }
            } else {
              this.dialogUniqueCode = true
            }
          } else {
            this.$router.push({ name: 'non_active' }).catch(() => {})
          }
        }
      } else {
        this.paused = false
      }
    },
    successPosition: async function(position) {
      this.destinations.push({
        lat: Number(position.coords.latitude),
        lng: Number(position.coords.longitude)
      })
      const radiusDinein = await this.$curDistance(this.origins[0].lat, this.origins[0].lng, this.destinations[0].lat, this.destinations[0].lng)
      if (radiusDinein > 250) {
        this.$store.state.block_tooLong = true
      } else {
        this.$router.push({ name: 'total_guest_dinein' }).catch(() => {})
      }
    },
    failurePosition: function() {
      if (this.$store.state.selected_type === 'DELIVERY') {
        this.$store.state.must_allow_location = true
      }
      this.$store.state.block_location = true
    },
    async validateCode() {
      this.error_unique_code = ''
      this.loadingCode = true
      try {
        await dineinCheck(this.form)
        this.$store.state.loading_axios = false
        this.$store.state.block_camera = false
        this.$router.push({ name: 'total_guest_dinein' }).catch(() => {})
      } catch (e) {
        this.error_unique_code = e.string
      }
      this.loadingCode = false
      this.form.code = ''
    }
  }
}
</script>
